import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { TopCallTimesData, TopCallTimesMetricData } from './top-call-times.model';

@Injectable({
	providedIn: 'root'
})
export class TopCallTimesService {

	constructor(
		private cvApiService: CVApiService,
	) { }

  // Service Methods
  async LoadCallMetrics(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
		try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const response = await this.cvApiService.get<TopCallTimesMetricData>(`${renderEndpoint}/api/v2/topcalltimes/callmetrics/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed loading call metrics");
            throw err;
        }
	}

	async LoadTopCallTimes(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
		try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const response = await this.cvApiService.get<TopCallTimesData>(`${renderEndpoint}/api/v2/modules/topcalltimes/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed loading top call time data");
            throw err;
        }
	}

	async LoadDataForExport(moduleKey: string, format: string = 'excel') {
		try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
			const response = await this.cvApiService.get<string>(`${renderEndpoint}/api/v2/dashboards/modules/topcalltimes/${moduleKey}/export?format=${format}`);
					if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed loading top call time data for export");
            throw err;
        }
	}

}
